// ============================================================
// TheatrePlugin — theatre mode toggle
// Emits theatre:change for the host page to handle layout
// ============================================================
import type { IPlugin, PluginContext } from '../../core/types';
import { TheatreBtn } from './TheatreBtn';

export class TheatrePlugin implements IPlugin {
  readonly name = 'theatre';

  private ctx: PluginContext | null = null;
  private unsubs: Array<() => void> = [];
  private keyHandler: ((e: KeyboardEvent) => void) | null = null;

  init(ctx: PluginContext): void {
    this.ctx = ctx;

    this.unsubs.push(
      ctx.eventBus.on('theatre:change', (active: boolean) => {
        ctx.store.setState({ isTheatreMode: active });
      }),
    );

    // Alt+T hotkey
    this.keyHandler = (e: KeyboardEvent) => {
      if (e.code !== 'KeyT' || !e.altKey) return;
      const target = e.target as HTMLElement;
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.tagName === 'SELECT') return;

      e.preventDefault();
      e.stopPropagation();
      const body = document.getElementsByTagName('body')[0];
            body.classList.toggle('theatre');
      ctx.eventBus.emit('theatre:change', !ctx.store.getState().isTheatreMode);
    };
    document.addEventListener('keydown', this.keyHandler);

    ctx.uiRegistry.register('theatre-button', TheatreBtn);

    ctx.logger.debug('TheatrePlugin initialized');
  }

  destroy(): void {
    if (this.keyHandler) {
      document.removeEventListener('keydown', this.keyHandler);
      this.keyHandler = null;
    }
    this.ctx?.uiRegistry.unregister('theatre-button', TheatreBtn);
    this.ctx?.store.setState({ isTheatreMode: false });
    document.body.classList.remove('theatre');
    this.unsubs.forEach(fn => fn());
    this.unsubs = [];
    this.ctx = null;
  }
}
